module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-SemiBoldItalic.woff2?ffaf7dcabed2f0280752c6b38949d6b2";